// import { ENVIRONMENT } from './constants'
const getCallbackUrl = () => {
  const currentUrl = window.location.href;
  const splittedURL = currentUrl.split('/');
  const protocol = splittedURL[0];
  const siteUrl = splittedURL[2];
  return `${protocol}//${siteUrl}/callback`;
};

export const META_DATA_PREFIX = 'https://sehatafg.alem.health/';

export const AUTH_CONFIG = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientID: process.env.REACT_APP_AUTH0_CLIENT_ID,
  connection: process.env.REACT_APP_AUTH0_CONNECTION,
  audience: process.env.REACT_APP_AUTH0_AUDIENCE,
  redirectUri: getCallbackUrl(),
  responseType: 'token id_token',
  scope: 'openid email profile',
};

export const FORGOT_PASSWORD_ENDPOINT_SUFFIX = '/dbconnections/change_password';
